/**
 * Ein kleiner Lade-Hook. Kein SWR, kein React Query — die App hat sieben
 * Screens und eine Freundesgruppe als Publikum.
 */
import { useCallback, useEffect, useRef, useState } from 'react'
import { ApiFehler } from './client.js'

export interface Ladezustand<T> {
  daten: T | null
  fehler: string | null
  laedt: boolean
  neuLaden: () => void
}

export function useLaden<T>(lade: () => Promise<T>, abhaengig: unknown[] = []): Ladezustand<T> {
  const [daten, setDaten] = useState<T | null>(null)
  const [fehler, setFehler] = useState<string | null>(null)
  const [laedt, setLaedt] = useState(true)
  const [zaehler, setZaehler] = useState(0)
  const aktuell = useRef(0)

  useEffect(() => {
    const lauf = ++aktuell.current
    setLaedt(true)
    setFehler(null)
    lade()
      .then((ergebnis) => {
        if (aktuell.current === lauf) setDaten(ergebnis)
      })
      .catch((f: unknown) => {
        if (aktuell.current !== lauf) return
        setFehler(f instanceof ApiFehler ? f.message : 'Die Kammer ist vorübergehend nicht arbeitsfähig.')
      })
      .finally(() => {
        if (aktuell.current === lauf) setLaedt(false)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zaehler, ...abhaengig])

  const neuLaden = useCallback(() => setZaehler((z) => z + 1), [])
  return { daten, fehler, laedt, neuLaden }
}
